import { render, staticRenderFns } from "./PriceExtraSpecialUpdate.vue?vue&type=template&id=8b6930c8"
import script from "./PriceExtraSpecialUpdate.vue?vue&type=script&lang=js"
export * from "./PriceExtraSpecialUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports